import { mapState, mapGetters, mapActions } from 'vuex'

export const inventoryReportsMethods = mapActions(
  'retina/reports/inventory', [
    'createInventory', 'fetchPendingInventory'
  ]
)

export const sellersMethods = mapActions(
  'retina/sellers', [
    'fetchOptionsSellers'
  ]
)

export const pendingsMethods = mapActions(
  'retina/reports/pendings', [
    'createPending', 'deleteAllPendings'
  ]
)

export const consolidatedMethods = mapActions(
  'retina/reports/consolidated', [
    'createConsolidated'
  ]
)

export const groupingMethods = mapActions(
  'retina/reports/grouping', [
    'fetchGrouping', 'fetchGroupingToList', 'createGrouping', 'updateGrouping', 'deleteGrouping'
  ]
)

export const productsReportMethods = mapActions(
  'retina/reports/products', [
    'createProduct'
  ]
)

export const benchmarksMethods = mapActions(
  'retina/reports/benchmarks', [
    'createBenchmark'
  ]
)

export const sitesMethods = mapActions(
  'retina/reports/sites', [
    'fetchSites'
  ]
)

export const reportsMethods = mapActions(
  'retina/reports/reports', [
    'fetchBenchmarkReport',
    'fetchBenchmarkReportnoset',
    'fetchConsolidatedReport',
    'fetchConsolidatedReportnoset'
  ]
)

export const productsMethods = mapActions(
  'retina/products', [
    'selectProduct',
    'fetchProductsToList',
    'fetchProducts', 
    'fetchProductsReport',
    'enableQrScaning',
    'disableQrScaning',
    'setQrSerial',
    'setQrProduct'
  ])

export const warehouseMethods = mapActions(
  'retina/warehouse', [
    'setLoadingWarehouses',
    'fetchWarehouses', 
    'fetchOwnWarehouses',
    'setWarehouses',
    'clearWarehouses',
    'setOwnWarehouses',
    'clearOwnWarehouses',
    'selectWarehouse',
    'selectOwnWarehouse', 
    'selectUbication', 
    'clearWarehouse',
    'clearOwnWarehouse', 
    'clearUbication',
    'setConsultWarehouse',
    'setConsultOwnWarehouse'
  ])

export const retinaGroupsMethods = mapActions(
  'retina/retinaGroups', [
    'fetchRetinaGroups',
    'fetchRetinaGroupsDetail',
    'createUpdateRetinaGroups',
    'deleteRetinaGroups'
  ])

export const inventoryMethods = mapActions(
  'retina/inventory', [
    'saveOwnInventory',
    'finishOwnInventory',
    'fetchOwnStock',
    'sendOrder',

    'setWarehouseI',
    'clearWarehouseI',
    'setOwnWarehouseI',
    'clearOwnWarehouseI',
    'setUbicacionI',
    'clearUbicationI',
    
    'fetchInventory',
    'fetchInventoryList',
    'fetchOwnInventories',
    'fetchOwnInventoryReport',

    'setInventory',
    'setOwnInventory',
    'setTotalProducts',
    'setOwnTotalProducts',
    'setTotalProductsQuantity',
    'setOwnTotalProductsQuantity',
    'setTotalPending',
    'setOwnTotalPending',
    'setTotalPendingQuantity',
    'setOwnTotalPendingQuantity',
    'getTotalPendingQuantity',
    'getOwnTotalPendingQuantity',
    'clearInventory',
    'clearOwnInventory',

    'setStock',
    'setOwnStock',
    'setTotalStock',
    'setOwnTotalStock',
    'setTotalStockQuantity',
    'setOwnTotalStockQuantity',
    'clearStock',
    'clearOwnStock',

    'addItemInStockBySerial',
    'addItemInOwnStockBySerial',
    'removeItemInStockBySerial',
    'removeItemInOwnStockBySerial',
    'addItemInStockByLote',
    'addItemInOwnStockByLote',
    'removeItemInStockByLote',
    'removeItemInOwnStockByLote',

    'moveItemInInventoryToPendingkBySerial',
    'moveItemInOwnInventoryToOwnPendingkBySerial',
    'moveItemInInventoryToPendingByLote',
    'moveItemInOwnInventoryToOwnPendingByLote',

    'setSpent',
    'setTotalSpent',
    'setTotalSpentQuantity',
    'clearSpent',

    'setPending',
    'setOwnPending',
    'setTotalPending',
    'setOwnTotalPending',
    'clearPending',
    'clearOwnPending',
    'setPendingResults',
    'setOwnPendingResults',

    'addItemInSpentBySerial',
    'removeItemInSpentBySerial',
    'addItemInSpentByLote',
    'removeItemInSpentByLote',
    
    'moveItemPendingToStockBySerial',
    'moveItemOwnPendingToOwnStockBySerial',
    'moveItemPendingToStockByLote',
    'moveItemOwnPendingToOwnStockByLote',
     
    'setLoadingInventory',
    
    'enableInventoryCountMode', 
    'disableInventoryCountMode', 
    'enableOwnInventoryCountMode', 
    'disableOwnInventoryCountMode', 
    
    'enableInventoryCountSpentProducts',
    'disableInventoryCountSpentProducts',
    'enableOwnInventoryCountSpentProducts',
    'disableOwnInventoryCountSpentProducts',

    'enableInventoryCountReview',
    'disableInventoryCountReview',
    'setInventoryCountReview',
    'enableOwnInventoryCountReview',
    'disableOwnInventoryCountReview',
    'setOwnInventoryCountReview',
    
    'setInventoryOnlineMode',
    'setOwnInventoryOnlineMode',
    'sendEmail',
    'fetchInventoryReport',        
  ])

// ----------------------------------------------------------------

export const appAuthComputed = {
  ...mapState('appAuth', {
    appSession: (state) => state.appSession,
  }),
  ...mapGetters('appAuth', ['appLoggedIn','updateCompanyInfo']),
}

export const appAuthMethods = mapActions(
  'appAuth', ['appLogIn', 'companyInfoExists'])


export const authComputed = {
  ...mapState('auth', {
    currentSession: (state) => state.currentSession,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions(
  'auth', ['logIn', 'logOut', 'register',
  'resetPassword', 'setUserActiveSection'])


export const languageComputed = {
  ...mapState('language', {
    language: (state) => state.language,
  })
}
  
export const languageMethods = mapActions(
  'language', ['setLanguage'])

export const usersComputed = {
  ...mapState('users', {
    cached: (state) => state.cached,
  }),
}

export const usersMethods = mapActions(
  'users', [
    'fetchUsers', 'createUpdateUsers',
    'deleteUsers', 'changePassword', 
    'updatePhotos', 'fetchUsersDetail',
    'fetchUsersForOptions', 'checkIfUserExists',
    'registerUsers']
)

export const permsComputed = {
  ...mapState('perms', {
    cached: (state) => state.cached,
  }),
}

export const permsMethods = mapActions(
  'perms', ['fetchPerms', 'createUpdatePerms',
  'deletePerms', 'fetchPermsDetail'])


export const groupsComputed = {
  ...mapState('groups', {
    cached: (state) => state.cached,
  }),
}

export const groupsMethods = mapActions(
  'groups', ['fetchGroups', 'createUpdateGroups', 
  'deleteGroups', 'fetchGroupsDetail'])

export const appSectionsComputed = {
  ...mapState('appSections', {
    cached: (state) => state.cached,
  }),
}

export const appSectionsMethods = mapActions(
  'appSections', ['fetchAppSections', 'createUpdateAppSections',
  'deleteAppSections', 'fetchAppSectionsDetail'])

export const companyInfoComputed = {
  ...mapState('companyInfo', {
    cached: (state) => state.cached,
  }),
}

export const companyInfoMethods = mapActions(
  'companyInfo', ['fetchCompanyInfo', 'createUpdateCompanyInfo', 'setFileCompanyInfo'])

  // Periodic tasks helpers
export const periodicTasksMethods = mapActions(
  'periodicTasks', ['fetchPeriodicTasks', 'createUpdatePeriodicTasks', 
  'deletePeriodicTasks', 'fetchPeriodicTasksDetail', 'fetchPeriodicTasksOptions',
  'getLiveResultsPeriodicTasks', 'executeManuallyPeriodicTasks'])

export const periodicTasksResultsMethods = mapActions(
    'periodicTasksResults', ['fetchPeriodicTasksResults', 'createUpdatePeriodicTasksResults', 
    'deletePeriodicTasksResults', 'fetchPeriodicTasksResultsDetail'])

export const periodicTasksSolarScheduleMethods = mapActions(
  'periodicTasksSolarSchedule', ['fetchPeriodicTasksSolarSchedule', 'createUpdatePeriodicTasksSolarSchedule', 
  'deletePeriodicTasksSolarSchedule', 'fetchPeriodicTasksSolarScheduleDetail'])

export const periodicTasksIntervalScheduleMethods = mapActions(
  'periodicTasksIntervalSchedule', ['fetchPeriodicTasksIntervalSchedule', 'createUpdatePeriodicTasksIntervalSchedule', 
  'deletePeriodicTasksIntervalSchedule', 'fetchPeriodicTasksIntervalScheduleDetail'])

export const periodicTasksClockedScheduleMethods = mapActions(
  'periodicTasksClockedSchedule', ['fetchPeriodicTasksClockedSchedule', 'createUpdatePeriodicTasksClockedSchedule', 
  'deletePeriodicTasksClockedSchedule', 'fetchPeriodicTasksClockedScheduleDetail'])

export const periodicTasksCrontabScheduleMethods = mapActions(
  'periodicTasksCrontabSchedule', ['fetchPeriodicTasksCrontabSchedule', 'createUpdatePeriodicTasksCrontabSchedule', 
  'deletePeriodicTasksCrontabSchedule', 'fetchPeriodicTasksCrontabScheduleDetail'])